import { Plus } from 'assets/Icons'
import { TextInput } from 'components/Form'
import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

const Header = ({ filter, setFilter }) => {
	const { search } = filter
	const navigate = useNavigate()
	const role = useSelector(state => state?.user?.user?.user_type)
	return (
		<div className='mb-5'>
			<div className='flex items-center justify-between mb-3'>
				<h1 className='text-[#292A32] dark:text-[#FFFFFF] text-[18px] lg:text-[24px] font-semibold'>
					O'qituvchilar
				</h1>
				{role === 'admin' ? (
					<Fragment>
						<button
							className='border-none outline-none inline-block md:hidden'
							onClick={() => navigate('/account/teachers/create')}
						>
							<Plus
								classname={'size-[24px] text-[#292A32] dark:text-[#FFFFFF]'}
							/>
						</button>
						<span className='hidden md:flex'>
							<button
								className='success-btn'
								onClick={() => navigate('/account/teachers/create')}
							>
								O'qituvchi qo'shish
							</button>
						</span>
					</Fragment>
				) : (
					<></>
				)}
			</div>
			<TextInput
				size='small'
				placeholder='O’qituvchining ismi bo’yicha izlash'
				value={search}
				onChange={search => setFilter({ ...filter, search })}
			/>
		</div>
	)
}

export default Header
